module.exports = __webpack_public_path__ + "img/404.4cf6930.png";